
const state = {
  agency_id: null,
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'title' },
]

export default state
